let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if (api_token) window.API_ACCESS = api_token;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    document
      .querySelectorAll(
        '.product-form__input input[type="radio"], .product-form__input select'
      )
      .forEach((option) => {
        option.addEventListener("change", this.whichInputUpdated.bind(option));
      });

    this.addEventListener("change", this.onVariantChange);

    this.optionTitles = this.getAttribute("data-option-titles").split(",");
    this.updateOptions();
    this.updateMasterId();
    this.renderProductInfo();
    this.updateAdditionSizes();
    this.updateVariantInput();
  }

  whichInputUpdated(element) {
    var optionname = element.target
      .closest(".product-form__input")
      .querySelector(".form__label").dataset.optionname;

    document
      .querySelectorAll(`.product-form__input`)
      .forEach((option) => option.classList.remove("activeset"));

    document
      .querySelectorAll(`.form__label[data-optionname="${optionname}"]`)
      .forEach((option) =>
        option.closest(".product-form__input").classList.add("activeset")
      );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateDetailsTable();
      this.updateAssemblyInstructions();
      this.updateAdditionSizes();
    }

    var allSelectors = document.querySelectorAll(
      ".section-main-product .product__variant-selector.option-select"
    );

    allSelectors.forEach((selector) => {
      if (selector != this) {
        this.updatePairUI(selector, this);
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const pdpGallery = document.querySelector('[id^="productMainSlider-"]');

    if (pdpGallery) {
      pdpGallery.scrollToSlide(this.currentVariant.featured_media.position - 1);
    }

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.closest(".quick-add-modal")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;

      const newUrl = new URL(window.location);
      const newQueryString = new URLSearchParams(newUrl.search);
      newQueryString.set("variant", this.currentVariant.id);
      
      newUrl.path = this.dataset.url;
      newUrl.search = newQueryString;

      window.history.replaceState(
        {},
        "",
        `${newUrl.pathname}${newUrl.search}`
      );
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.updateURL();
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
  }

  updateDetailsTable() {
    const requestedVariantId = this.currentVariant.id;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=product-details-table`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        //product details table
        const detailsRows = html.querySelectorAll(".js-product-details tr");
        if (detailsRows.length) {
          detailsRows.forEach((row) => {
            if (document.getElementById(row.getAttribute("id"))) {
              document.getElementById(row.getAttribute("id")).innerHTML =
                row.innerHTML;
            }
          });
        }
      });
  }

  updateAssemblyInstructions() {
    const requestedVariantId = this.currentVariant.id;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=product-assembly-instructions`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        //product instruction manual
        const currentInstructionsButton = document.querySelector('.js-product-assembly-instructions');
        const newInstructionsButton = html.querySelector(".js-product-assembly-instructions");
        if (currentInstructionsButton && newInstructionsButton) {
          currentInstructionsButton.innerHTML = newInstructionsButton.innerHTML;
        }
      });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const destinationSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationSticky)
          destinationSticky.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        // delivery dates
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        const deliveryFieldName = "properties[Estimated Delivery]";
        const deliveryDateSource = html.querySelector('[name="' + deliveryFieldName + '"');
        const deliveryDateDestination = productForm.querySelector('[name="' + deliveryFieldName + '"');

        if (deliveryDateDestination) { 
          deliveryDateDestination.remove() 
        };
        
        if (deliveryDateSource) {
          productForm.appendChild(deliveryDateSource);
        }

        //stock info
        const stockSource = html.querySelector(".js-stock-info");
        const stockDestination = document.querySelector(".js-stock-info");
        if (stockSource && stockDestination)
          stockDestination.innerHTML = stockSource.innerHTML;

        //price
        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (priceSticky) priceSticky.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        const addButtonUpdatedText = html.querySelector(`#ProductSubmitButton-${sectionId} span`)?.textContent;
        
        let requiredAddButtonText = window.variantStrings.soldOut;
        if (!addButtonUpdated.hasAttribute("disabled")) {
          requiredAddButtonText = addButtonUpdatedText;
        }

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          requiredAddButtonText
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  updateAdditionSizes() {
    const additionSizeSelects = document.querySelectorAll(
      ".product__complete-set-options-item"
    );

    if (additionSizeSelects.length) {
      this.optionTitles.forEach((optionTitle, index) => {
        if (optionTitle.toLowerCase().includes("size")) {
          additionSizeSelects.forEach((select) => {
            if (
              select
                .querySelector("label")
                .innerHTML.toLowerCase()
                .includes("size")
            ) {
              const selectElement = select.querySelector("select");
              if (selectElement) {
                const selectOptions = selectElement.querySelectorAll("option");
                selectOptions.forEach((option) => {
                  if (option.value === this.currentVariant.options[index]) {
                    selectElement.value = this.currentVariant.options[index];
                    selectElement.dispatchEvent(new Event("change"));
                  }
                });
              }
            }
          });
        }
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    if (!addButton) return;

    if (text) {
      addButtonText.textContent = text;
      if (addButtonSticky) addButtonTextSticky.textContent = text;
    } 

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
    } else {
      addButton.removeAttribute("disabled");
      if (addButtonSticky) addButtonSticky.removeAttribute("disabled");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-${this.dataset.section}-support`
    );

    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky)
      addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");

    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original) {
    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = "";
    var originalSelectedItemValue = "";

    if (originalTagName.includes("selects")) {
      var itemSelect = original.querySelector(".activeset select");
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    } else {
      originalSelectedItem = original.querySelector(
        '.activeset input[type="radio"]:checked'
      );
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if (pairedTagName.includes("selects")) {
      var event = new Event("change");
      paired.querySelector(".activeset select").value =
        originalSelectedItemValue;
      paired
        .querySelector(
          `.activeset option[data-value="${originalSelectedItemValue}"`
        )
        .click();
      paired.dispatchEvent(event);
    } else {
      if (paired.querySelector(`.activeset input[type="radio"]:checked`)) {
        paired.querySelector(
          `.activeset input[type="radio"]:checked`
        ).checked = false;
      }

      var newTarget = paired
        .querySelector(
          `.activeset label[data-value="${originalSelectedItemValue}"`
        )
        .getAttribute("for");

      if (paired.querySelector(`.activeset input[type="radio"]#${newTarget}`)) {
        paired.querySelector(
          `.activeset input[type="radio"]#${newTarget}`
        ).checked = true;
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const value = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;

      const label = fieldset.querySelector(".js-option-value");
      if (label) {
        label.innerText = value;
      }

      return value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

//scroll to top button
const toTopButtons = document.querySelectorAll(".js-back-to-top");
if (toTopButtons.length) {
  toTopButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}

//announcement bar dismiss
const dismissButtons = document.querySelectorAll(".js-announcement-dismiss");
const announcements = document.querySelectorAll(".announcement-bar");
if (dismissButtons.length && announcements.length) {
  if (sessionStorage.getItem("hide_announcements") == "true") {
    announcements.forEach((el) => {
      el.classList.add("hidden");
    });
  }

  dismissButtons.forEach((button) => {
    button.addEventListener("click", () => {
      announcements.forEach((el) => {
        el.classList.add("hidden");
      });

      sessionStorage.setItem("hide_announcements", "true");

      setAnnouncementHeightVariable();
    });
  });
}

const summaries = document.querySelectorAll("summary[data-auto-close]");
if (summaries) {
  summaries.forEach((summary) => {
    summary.addEventListener("click", closeOpenedDetails);
  });

  function closeOpenedDetails() {
    summaries.forEach((summary) => {
      let detail = summary.parentNode;
      if (detail != this.parentNode) {
        detail.removeAttribute("open");
      }
    });
  }
}

function setAnnouncementHeightVariable() {
  const announcement = document.querySelector(".announcement-bar");

  let height = 0;

  if (!announcement) return;

  height = announcement.offsetHeight;

  document.documentElement.style.setProperty(
    "--announcement-height",
    `${height}px`
  );
}

setAnnouncementHeightVariable();

//tracking events
const productCardLinks = document.querySelectorAll(".js-product-card-link");
if (productCardLinks) {
  productCardLinks.forEach((link) => {
    link.addEventListener("click", () => {
      Shopify.analytics.publish("select_item", {
        item_list_id: link.getAttribute("data-list-id"),
        item_list_name: link.getAttribute("data-list-name"),
        item_id: link.getAttribute("data-product-id"),
        item_name: link.getAttribute("data-product-name"),
        price: link.getAttribute("data-product-price"),
      });
    });
  });
}

const wishlistButtons = document.querySelectorAll(
  'button[data-swaction="addToWishlist"]'
);
if (wishlistButtons) {
  wishlistButtons.forEach((button) => {
    button.addEventListener("click", () => {
      Shopify.analytics.publish("add_to_wishlist", {
        currency: button.getAttribute("data-currency"),
        value: button.getAttribute("data-price"),
        item_id: button.getAttribute("data-product-id"),
        item_variant: button.getAttribute("data-variant-id"),
        item_name: button.getAttribute("data-title"),
        price: button.getAttribute("data-price"),
      });
    });
  });
}


if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
      return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];

      if (value == option.value || value == option.innerHTML) {
          selector.selectedIndex = i;
          return i;
      }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
      var hiddenField = document.createElement("input");

      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
  },

  initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');

      if (value && this.provinceEl.options.length > 0) {
          Shopify.setSelectorByValue(this.provinceEl, value);
      }
  },

  countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);

      this.clearOptions(this.provinceEl);

      if (provinces && provinces.length == 0) {
          this.provinceContainer.style.display = 'none';
      } else {
          for (var i = 0; i < provinces.length; i++) {
              var opt = document.createElement('option');
              opt.value = provinces[i][0];
              opt.innerHTML = provinces[i][1];
              this.provinceEl.appendChild(opt);
          }

          this.provinceContainer.style.display = "";
      }
  },

  clearOptions: function(selector) {
      while (selector.firstChild) {
          selector.removeChild(selector.firstChild);
      }
  },

  setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
          var opt = document.createElement('option');

          opt.value = values[i];
          opt.innerHTML = values[i];
          selector.appendChild(opt);
      }
  }
};

Shopify.formatMoney = function(cents, format) {
  console.log("--------", cents, format);
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }

  return formatString.replace(placeholderRegex, value);
}
